import styled from "styled-components";

const TypeListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const TypeItem = styled.div`
  width: max-content;

  border: 1px solid ${({ isSelected }) => (isSelected ? "#502CE8" : "#d6d6d6")};
  border-radius: 999px;

  padding: 13px 20px;

  font-weight: 500;
  font-size: 18px;
  color: ${({ isSelected }) => (isSelected ? "#502CE8" : "#6a6a6a")};

  cursor: pointer;
`;

const TypeList = ({ selectedType, setSelectedType }) => {
  const handleClickType = (e) => {
    if (selectedType.includes(e.target.id)) {
      setSelectedType(selectedType.filter((item) => item !== e.target.id));
      return;
    }
    if (selectedType.length >= 3) return;
    setSelectedType([...selectedType, e.target.id]);
  };

  const types = [
    { id: "CD000001", value: "반영구" },
    { id: "CD000002", value: "미술" },
    { id: "CD000003", value: "타투" },
    { id: "CD000004", value: "패션" },
    { id: "CD000005", value: "스냅사진" },
    { id: "CD000006", value: "헤어" },
    { id: "CD000007", value: "광고촬영" },
    { id: "CD000008", value: "커머스" },
    { id: "CD000009", value: "바디/왁싱" },
    { id: "CD000010", value: "메이크업" },
    { id: "CD000011", value: "기타" },
  ];
  return (
    <TypeListContainer>
      {types.map(({ id, value }) => (
        <TypeItem key={id} id={id} onClick={handleClickType} isSelected={selectedType.includes(id)}>
          {value}
        </TypeItem>
      ))}
    </TypeListContainer>
  );
};

export default TypeList;
